import React from 'react';
import { useIntl } from 'react-intl';
import { Surface, Navigation, NavigationItem, useMediaQuery, mediaQueries } from '@americanexpress/dls-react';
const AMEX_LOGO = 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-line.svg';
const Header = () => {
  const isDesktopView = useMediaQuery(mediaQueries.LG_UP);
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Surface, {
    variant: "foreground",
    className: "nav-sticky nav nav-header pad-lr shadow-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: AMEX_LOGO,
    alt: "American Express"
  }), isDesktopView && /*#__PURE__*/React.createElement(Navigation, {
    variant: "horizontal"
  }, /*#__PURE__*/React.createElement(NavigationItem, {
    label: formatMessage({
      id: 'invoiceManagement'
    }),
    href: "/"
  })));
};
export const TestableHeader = Header;
export default Header;